export default "__VITE_ASSET__4A7chieB__"